"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailsDrawer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const overlayscrollbars_react_1 = require("overlayscrollbars-react");
const Styled = __importStar(require("./DetailsDrawer.styles"));
const DetailsDrawer = ({ isOpen, header, children }) => {
    return isOpen ? ((0, jsx_runtime_1.jsx)(Styled.DetailsDrawer, { children: (0, jsx_runtime_1.jsx)(Styled.DetailsWrapper, { children: (0, jsx_runtime_1.jsx)(overlayscrollbars_react_1.OverlayScrollbarsComponent, { defer: true, options: { scrollbars: { autoHide: 'scroll' } }, children: (0, jsx_runtime_1.jsx)(material_1.Fade, { in: true, timeout: 500, children: (0, jsx_runtime_1.jsxs)(Styled.Details, { children: [header && (0, jsx_runtime_1.jsx)(Styled.Header, { variant: "h2", children: header }), children] }) }) }) }) })) : null;
};
exports.DetailsDrawer = DetailsDrawer;
